// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Cldgc","today":"Header_today__R8Q9x","icon":"Header_icon__yhDa8","nightmode_button":"Header_nightmode_button__yJmot"};